/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { TfiClose } from "react-icons/tfi";
import { authenticationService } from "../../service/authentication";
import CustomToast from "../toaster";
import { helperFunctions } from "../../utils/helper";
import { triggerToast } from "../toaster/toastManager";
import CustomLoader from "../loader/loader";

interface AlertModalProps {
  show: boolean;
  onHide: () => void;
  title: string;
  message: string;
  onConfirm: () => void;
  isLoading?: boolean;
}

const AlertModal: React.FC<AlertModalProps> = ({
  show,
  onHide,
  title,
  message,
  onConfirm,
  isLoading = false,
}) => {
  const handleConfirm = (event: any) => {
    const button = event.target; // Get the button element
    button.disabled = true; // Disable the button
    // Close the modal first, then trigger confirm
    onHide();
    onConfirm();
  };

  return (
    <Modal centered size="sm" show={show}>
      {/* Loader removed from inside the modal. Show it globally after confirm. */}
      <div>
        <div className="modalHead">
          <p className="modalHeadText2 mx-3 my-2">{title}</p>
          <div onClick={onHide} className="p-2 mx-2 wrapCloseIcon">
            <TfiClose fill="#FFFFFF" />
          </div>
        </div>
        <div className="text-center mt-3 mb-5">
          <p className="normalText2 ">
            Are you sure you want to <br />
            <span>
              <strong>{message}</strong>
            </span>
          </p>
        </div>
        <div className="d-flex justify-content-around pb-3">
          <button onClick={onHide} className="modalCancelBtn2">
            Cancel
          </button>
          <button
            onClick={(e) => handleConfirm(e)}
            className="squareOrangeBtn3"
          >
            Confirm
          </button>
        </div>
      </div>
    </Modal>
  );
};

interface eSignModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: (remark: string) => void;
  needRemraks: boolean;
  screenName: string;
}

interface Errors {
  esign?: string;
  remark?: string;
}

export const EsignModal: React.FC<eSignModalProps> = ({
  show,
  onHide,
  onConfirm,
  needRemraks,
  screenName,
}) => {
  const [errors, setErrors] = useState<Errors>({});
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("");
  const defaultFormData = {
    esign: "",
    remark: "",
  };
  const [formData, setFormData] = useState(defaultFormData);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [loader, setLoader] = useState(false);

  const handleAddFieldOnChange = (event: any) => {
    const { name, value } = event.target;
    setFormData((prevFormData: any) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const checkSpecialChar = (e: any) => {
    if (!/[0-9a-zA-Z]/.test(e.key)) {
      e.preventDefault();
    }
  };

  const handleConfirm = (event: any) => {
    event.preventDefault();
    
    // Prevent multiple submissions
    if (isButtonDisabled) return;
    
    const errors: Errors = {};

    if (!formData.esign) {
      errors.esign = "Please enter Password";
    }
    if (!formData.remark && needRemraks) {
      errors.remark = "Please enter Remarks";
    }
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }
    // const button = event.target; // Get the button element
    // button.disabled = true;
    setErrors({});
    setIsButtonDisabled(true);
    EsignValidationProcess();
  };

  const EsignValidationProcess = async () => {
    const dataToSend = {
      password: formData.esign,
      interface_name: screenName
    };
setLoader(true);
    try {
      const response = await authenticationService.validateEsign(dataToSend);
      if (response.status && response.statusCode === 200) {
        //setIsButtonDisabled(true);
        onConfirm(formData.remark);
        // setToastType("success");
        // setToastMessage(response.message);
        triggerToast(response.message, "success");
        setFormData(defaultFormData);
        handleClose();
      } else {
        // setToastType("error");
        // setToastMessage(response.message);
        triggerToast(response.message, "error");
        setIsButtonDisabled(false);
      }
      //handleClose();
    } catch (error) {
      console.error("Plate response", error);
      triggerToast("An error occurred. Please try again.", "error");
      setIsButtonDisabled(false);
    }finally{
      setLoader(false);
    }
  };

  const handleClose = () => {
    onHide();
    setFormData(defaultFormData);
    setErrors({});
    setIsButtonDisabled(false);
  };

  return (
    <>
      {/* <CustomToast
    show={showToast}
    onClose={() => setShowToast(false)}
    delay={1000}
    message={toastMessage}
    toastType={toastType}
    /> */}

      <Modal
        centered
        aria-labelledby="contained-modal-title-vcenter"
        show={show}
      >
        <div>
          <div className="modalHead">
            <p className="modalHeadText2 mx-3 my-2">E-Sign</p>
            <div onClick={handleClose} className="p-2 mx-2 wrapCloseIcon">
              <TfiClose fill="#FFFFFF" />
            </div>
          </div>

          <div className="mt-3">
            <p className="normalText2 ">
              E - Signature indicates manual verification. Please cross-check
              the details before signing
            </p>
          </div>

       

      <form
  autoComplete="off"
  className="my-1 mx-3 px-2"
  onSubmit={handleConfirm}
>
  <div className="row">
    {/* Password Field */}
    <div className="col-md-6 mb-3">
      <label className="d-block text-start">
        Password<span style={{ color: "red" }}>*</span>
      </label>
      <input
        type="password"
        name="esign"
        id="esign"
        className="form-control"
        value={formData.esign}
        onChange={handleAddFieldOnChange}
      />
      {errors.esign && <p className="errorText">{errors.esign}</p>}
    </div>

    {/* Remarks Field */}
    {needRemraks && (
      <div className="col-md-6 mb-3">
        <label className="d-block text-start">
          Remarks<span style={{ color: "red" }}>*</span>
        </label>
        <input
          type="text"
          name="remark"
          id="remark"
          className="form-control"
          value={formData.remark}
          onChange={handleAddFieldOnChange}
          onKeyDown={(e) => helperFunctions.textFieldValidationCheck(e)}
        />
        {errors.remark && <p className="errorText">{errors.remark}</p>}
      </div>
     )} 
  </div>

  {/* Action Buttons */}
  <div className="d-flex justify-content-end" style={{ fontSize: "small" }}>
    <button type="button" onClick={handleClose} className="modalCancelBtn2 m-3">
      Cancel
    </button>
    <button type="submit" disabled={isButtonDisabled} className="squareOrangeBtn3 m-3">
      Confirm
    </button>
  </div>
</form>
{loader && <CustomLoader />}
        </div>
      </Modal>
    </>
  );
};

export default AlertModal;
